$(function() {
    if ($('.dedicated-servers-list').length > 0) {
        // Page: Dedicated Servers - first filters

        $('#dedicatedServersProcessor').select2MultiCheckboxes({
            theme: 'first-filter',
            templateSelection: function(selected) {
                if (selected.length > 0) {
                    return $('#dedicatedServersProcessor').data('placeholder') + ' (' + selected.length + ')';
                } else {
                    return $('#dedicatedServersProcessor').data('placeholder');
                }
            }
        });

        $('#dedicatedServersCores').select2MultiCheckboxes({
            theme: 'first-filter',
            templateSelection: function(selected) {
                if (selected.length > 0) {
                    return $('#dedicatedServersCores').data('placeholder') + ' (' + selected.length + ')';
                } else {
                    return $('#dedicatedServersCores').data('placeholder');
                }
            }
        });

        $('#dedicatedServersFrequency').select2MultiCheckboxes({
            theme: 'first-filter',
            templateSelection: function(selected) {
                if (selected.length > 0) {
                    return $('#dedicatedServersFrequency').data('placeholder') + ' (' + selected.length + ')';
                } else {
                    return $('#dedicatedServersFrequency').data('placeholder');
                }
            }
        });

        $('#dedicatedServersMemory').select2MultiCheckboxes({
            theme: 'first-filter',
            templateSelection: function(selected) {
                if (selected.length > 0) {
                    return $('#dedicatedServersMemory').data('placeholder') + ' (' + selected.length + ')';
                } else {
                    return $('#dedicatedServersMemory').data('placeholder');
                }
            }
        });

        $('#dedicatedServersDisks').select2MultiCheckboxes({
            theme: 'first-filter',
            templateSelection: function(selected) {
                if (selected.length > 0) {
                    return $('#dedicatedServersDisks').data('placeholder') + ' (' + selected.length + ')';
                } else {
                    return $('#dedicatedServersDisks').data('placeholder');
                }
            }
        });

        $('#dedicatedServersNetwork').select2MultiCheckboxes({
            theme: 'first-filter',
            templateSelection: function(selected) {
                if (selected.length > 0) {
                    return $('#dedicatedServersNetwork').data('placeholder') + ' (' + selected.length + ')';
                } else {
                    return $('#dedicatedServersNetwork').data('placeholder');
                }
            }
        });

        // Page: Dedicated Servers - second filters

        $('#dedicatedServersResultsPer').select2({
            theme: 'second-filter',
            width: 'element',
            minimumResultsForSearch: -1
        });

        $('#dedicatedServersResultsOrder').select2({
            theme: 'second-filter',
            width: 'element',
            minimumResultsForSearch: -1
        });
    }
});